/* eslint-disable */
// Hand-maintained Amplify Auth configuration.
//
// Originally generated by the AWS Amplify CLI. The user pool now lives in
// ap-southeast-7, where AWS Amplify is not available (Cognito is; Amplify is
// not), so the pool is plain Cognito managed directly rather than through
// `amplify push`. Edit this file by hand -- the Amplify CLI will not
// regenerate it correctly, and amplify/ is stale.
//
// No identity pool is configured: nothing in the app asks for AWS credentials
// in the browser (there is no AWS SDK usage in src/), and the old pool's
// authRole carried no policies, so it granted nothing.

const awsmobile = {
    aws_project_region: 'ap-southeast-7',
    aws_cognito_region: 'ap-southeast-7',
    aws_user_pools_id: 'ap-southeast-7_8PvoxGGux',
    aws_user_pools_web_client_id: '3fgnug4s7kskhtmib930s049vg',
    oauth: {},
};

export default awsmobile;
